import Logger from '../util/Logger';
import { popinApi } from './api';

const getLayout = (type, eventId) => {
  return Promise.resolve().then(() => {
    if (!eventId) {
      Logger.info('reject getLayout()');
      throw Error('Must pass an eventId as a param');
    } else {
      return popinApi.get(`/documents/layout?event_id=${eventId}&type=${type}`);
    }
  }).catch(error => {
    // This will be handled in the saga
    return { layoutError: error };
  });
};

const updateLayout = (type, eventId, sections) => {
  return Promise.resolve().then(() => {
    if (!eventId) {
      Logger.info('reject updateLayout()');
      throw Error('Must pass an eventId as a param');
    } else {
      if (!sections || sections.length === 0) {
        return popinApi.post(`/documents/layout/reset`, {
          type: type,
          event_id: eventId,
        });
      } else {
        return popinApi.post(`/documents/layout`, {
          type: type,
          event_id: eventId,
          sections: sections
        });
      }
    }
  });
};

export const documentsApi = {

  getCreatorReportLayout: (eventId) => {
    return getLayout('creator_report', eventId);
  },

  updateCreatorReportLayout: (eventId, sections) => {
    return updateLayout('creator_report', eventId, sections);
  }

};
